<script setup>
import { ref, onMounted, defineProps, defineModel, watch } from 'vue' 
import debounce from 'lodash.debounce'
import LocationApi from '@/services/LocationApi';

const crtProps = defineProps(['label', 'variant', 'density', 'hideDetails', 'companyId', 'strict', 'isLoaded']);
const locations = ref([])
const model = defineModel({type: Object, default: { locationId: 0, name: ""} })
const selectedLocation = ref()  
const loading = ref(false)

const searchLocations = debounce(async (term) => {

    if(crtProps.strict == true && !model.value?.locationId && (!crtProps.companyId || crtProps.companyId <= 0))
        return;
    loading.value = true
    LocationApi.search({ offset: 0, limit: 25, search: term, companyId: crtProps.companyId }).then((response) => {
        if (response && response.data && Array.isArray(response.data.locations)) {
            locations.value = response.data.locations;   
        }
    }).finally(() => {
        loading.value = false
         if(term) {
            selectedLocation.value = term
        }
    })
})

onMounted(() => {
    if(model.value && model.value.locationId > 0 && model.value.name) {
        searchLocations(model.value.name)
    }
    else {
        searchLocations(undefined)
    }
})

const handleLocationUpdate = (value) => {
    let location = locations.value.find(x => x.locationId == value);
    if(location) {
        model.value = location;
    }
    else {
        model.value = { locationId: 0, name: ""};
    }
}

watch(model, (value) => {
    
    if(value && value.locationId > 0 && value.name) {
        searchLocations(value.name)
    }
    else {
        searchLocations(undefined)
    }
});

watch(() => crtProps.companyId, (first, second) => {
    
    if(crtProps.isLoaded !== false && first != second) {
        selectedLocation.value = null;
        searchLocations(undefined);
    }
});

</script>

<template>
        <div :class="crtProps.class">
            <v-autocomplete
                :variant="crtProps.variant ? crtProps.variant : 'solo'" 
                item-title="name"
                item-value="locationId" 
                :density="crtProps.density ? crtProps.density : 'compact'" 
                :label="crtProps.label"
                :loading="loading"
                :items="locations"
                v-model="selectedLocation"
                @update:search="searchLocations"
                @update:model-value="handleLocationUpdate"
                autocomplete="one-time-code"
                :hide-details="crtProps.hideDetails != undefined ? crtProps.hideDetails : true"
                :clearable="true">
            </v-autocomplete>
        </div>
</template>